var _path, _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2667 1.73328L23.1805 2.13941C23.318 1.83008 23.2897 1.4722 23.1052 1.18836C22.9208 0.904527 22.6052 0.733276 22.2667 0.733276V1.73328ZM1.7334 1.73328V0.733276C1.18111 0.733276 0.733398 1.18099 0.733398 1.73328L1.7334 1.73328ZM22.2667 14.9333V15.9333C22.6052 15.9333 22.9208 15.762 23.1052 15.4782C23.2897 15.1944 23.318 14.8365 23.1805 14.5271L22.2667 14.9333ZM19.3334 8.33328L18.4196 7.92714C18.3047 8.1857 18.3047 8.48085 18.4196 8.73941L19.3334 8.33328ZM22.2667 0.733276H1.7334V2.73328H22.2667V0.733276ZM0.733398 1.73328V14.9333H2.7334V1.73328H0.733398ZM1.7334 15.9333H22.2667V13.9333H1.7334V15.9333ZM23.1805 14.5271L20.2472 7.92714L18.4196 8.73941L21.3529 15.3394L23.1805 14.5271ZM20.2472 8.73941L23.1805 2.13941L21.3529 1.32714L18.4196 7.92714L20.2472 8.73941ZM2.7334 22.9999V14.9333H0.733398V22.9999H2.7334Z",
    fill: "#FFE5F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 6,
    height: 5,
    fill: "#FFE5F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 2,
    width: 6,
    height: 5,
    fill: "#FFE5F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 6,
    height: 4,
    fill: "#FFE5F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 6,
    height: 4,
    fill: "#FFE5F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 6,
    height: 4,
    fill: "#FFE5F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.d45c43caacfe9de0574de5cd4511f2ab.svg";
export { ForwardRef as ReactComponent };